'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCrop32 = function MdCrop32(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 30v-20h-23.2v20h23.2z m0-23.4q1.4 0 2.4 1.1t1 2.3v20q0 1.3-1 2.3t-2.4 1.1h-23.2q-1.4 0-2.4-1.1t-1-2.3v-20q0-1.3 1-2.3t2.4-1.1h23.2z' })
        )
    );
};

exports.default = MdCrop32;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/crop-3-2.js
// module id = 1344
// module chunks = 168707334958949